console.log("Iurop functions!")

function enableCart() {
  document.querySelector('.toggle-cart-class')?.classList.add('loaded-cart');

  setTimeout(() => {
    document.querySelector('.toggle-cart-class')?.classList.add('loaded-cart');
  }, 500);
}

function buildExtraString(value) {
  const mapping = window.variantSizeMapping || {};
  const text = mapping[value];

  if (!text) return '';

  const svgIcon = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.66406 0.75C8.64844 0.75 9.52344 1.32422 9.96094 2.17188C10.8633 1.87109 11.9023 2.08984 12.6133 2.80078C13.3242 3.51172 13.543 4.55078 13.2422 5.45312C14.0898 5.89062 14.6641 6.76562 14.6641 7.75C14.6641 8.76172 14.0898 9.63672 13.2422 10.0742C13.543 10.9766 13.3242 11.9883 12.6133 12.6992C11.9023 13.4102 10.8633 13.6289 9.96094 13.3555C9.52344 14.2031 8.64844 14.75 7.66406 14.75C6.65234 14.75 5.77734 14.2031 5.33984 13.3555C4.4375 13.6289 3.42578 13.4102 2.71484 12.6992C2.00391 11.9883 1.78516 10.9766 2.05859 10.0742C1.21094 9.63672 0.664062 8.76172 0.664062 7.75C0.664062 6.76562 1.21094 5.89062 2.05859 5.45312C1.78516 4.55078 2.00391 3.51172 2.71484 2.80078C3.42578 2.08984 4.4375 1.87109 5.33984 2.17188C5.77734 1.32422 6.65234 0.75 7.66406 0.75ZM10.7539 6.46484C11 6.21875 11 5.80859 10.7539 5.5625C10.4805 5.28906 10.0703 5.28906 9.82422 5.5625L6.78906 8.59766L5.50391 7.3125C5.23047 7.03906 4.82031 7.03906 4.57422 7.3125C4.30078 7.55859 4.30078 7.96875 4.57422 8.21484L6.32422 9.96484C6.57031 10.2383 6.98047 10.2383 7.25391 9.96484L10.7539 6.46484Z" fill="#E9AFAF"></path></svg>';

  return `<div class="extra">${svgIcon} ${text}</div>`;
}

/* BoobUp · 22 oct 2026 · LINEA ORDENADA de la variante en los packs de Kaching.
   En DOS COLUMNAS (pedido de Oscar):
     izquierda → BOOST              derecha → | ✓ Para bustos 36E/DD · 38E/DD
                Beige - D                     40 (B, C, D, E/DD) · 42 ...
   La columna izquierda (.bu-vn__l) tiene el titulo y debajo la variante (mas
   chica y en gris), y SIEMPRE queda en su lugar. Las medidas (div.extra)
   ocupan las lineas que necesiten en su propia columna, con letra normal.
   El estilo esta en assets/overrides.css. */
function buildVariantLine(titleBase, selectedValues, extraString) {
  const variant = selectedValues ? `<span class="bu-vn__v">${selectedValues}</span>` : '';
  return `<div class="bu-vn"><div class="bu-vn__l"><span class="bu-vn__t">${titleBase}</span>${variant}</div>${extraString || ''}</div>`;
}

/* BoobUp · 22 oct 2026 · El TICKET (✓) ALINEADO CON "COPA" (pedido de Oscar).
   El icono de las medidas empieza exactamente en la misma vertical que la
   columna de copas (el boton "A", alineado con la etiqueta "Copa"). Como esa
   columna se corre segun el ancho del celular, se mide en cada pantalla y se
   ajusta el margen izquierdo de div.extra. Minimo 10px de separacion con
   "BOOST" (celulares angostos). Si el producto tiene un solo selector (sin
   columna de copa), queda con los 10px normales. */
function alignVariantLine(root, selector) {
  if (!root || !selector) return;
  const ex = root.querySelector('.bu-vn div.extra');
  if (!ex) return;
  const groups = selector.querySelectorAll('.kaching-bundles__swatch-buttons');
  if (groups.length < 2) {
    if (ex.style.marginLeft) ex.style.removeProperty('margin-left');
    return;
  }
  const g = groups[groups.length - 1];
  const target = g.querySelector('.kaching-bundles__swatch-buttons__button, .kaching-bundles-option-value') || g;
  const tr = target.getBoundingClientRect();
  if (!tr.width) return;
  const icon = ex.querySelector('svg');
  if (!icon) return;
  const ir = icon.getBoundingClientRect();
  if (!ir.width) return;
  const cur = parseFloat(getComputedStyle(ex).marginLeft) || 0;
  let m = Math.round(cur + (tr.left - ir.left));
  if (m < 10) m = 10;
  if (Math.abs(m - cur) >= 1) ex.style.setProperty('margin-left', m + 'px', 'important');
}

/* BoobUp · 17 oct 2026: lectura ROBUSTA de la variante elegida en cada
   selector de Kaching. Antes solo se buscaban grupos con la clase
   .kaching-bundles-option; en "Lleva 1" Kaching puede armar los selectores
   sin esa clase (o con <select>). Ahora:
   1) grupos con .kaching-bundles-option; si no hay,
   2) cualquier .kaching-bundles__swatch-buttons; y si tampoco,
   3) los <select> del selector.
   El valor se toma de data-value, title, aria-label o el texto del boton. */
function readSelectedOptionValues(selector) {
  let groups = selector.querySelectorAll('.kaching-bundles__swatch-buttons.kaching-bundles-option');
  if (!groups.length) groups = selector.querySelectorAll('.kaching-bundles__swatch-buttons');
  const values = [];
  if (groups.length) {
    for (let i = 0; i < groups.length && values.length < 2; i++) {
      const btn = groups[i].querySelector('.kaching-bundles__swatch-buttons__button--selected, [class*="button--selected"], [aria-checked="true"], [aria-pressed="true"]');
      let v = '';
      if (btn) {
        v = btn.getAttribute('data-value') || btn.getAttribute('title') || btn.getAttribute('aria-label') || (btn.textContent || '').trim();
      }
      values.push(v || '');
    }
  } else {
    const selects = selector.querySelectorAll('select');
    for (let i = 0; i < selects.length && values.length < 2; i++) {
      const s = selects[i];
      const opt = s.options && s.selectedIndex >= 0 ? s.options[s.selectedIndex] : null;
      values.push(opt ? (opt.getAttribute('data-value') || opt.value || (opt.textContent || '').trim()) : '');
    }
  }
  return { value1: values[0] || '', value2: values[1] || '' };
}

/* Visible = ocupa espacio en pantalla. En "Lleva 1" Kaching crea la cabecera
   .kaching-bundles__bar-variant-number pero OCULTA: si escribimos ahi, la
   linea no se ve. Por eso solo se usa si es visible; si no, se crea la propia
   (.extra-single). (17 oct 2026) */
function isShown(el) {
  if (!el) return false;
  const r = el.getBoundingClientRect();
  if (r.height <= 0 || r.width <= 0) return false;
  const cs = getComputedStyle(el);
  return cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0';
}

function updateBundleVariantTitles() {
  if (!document.querySelector('.h2.product-single__title')) return;

  const productTitleEl = document.querySelector('.h2.product-single__title');
  const titleBase = normalizeTitle(productTitleEl.textContent || '').split('®')[0].trim();
  let selectors = document.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper');
  if (!selectors.length) {
    selectors = document.querySelectorAll('.kaching-bundles__bar--selected .kaching-bundles__bar-variant-selects');
  }

  if (!selectors.length) return;

  for (let i = 0; i < selectors.length; i++) {
    const selector = selectors[i];
    const vals = readSelectedOptionValues(selector);
    const value1 = vals.value1;
    const value2 = vals.value2;

    const selectedValues = formatSelectedValues(value1, value2);
    const extraString = buildExtraString(value2) || buildExtraString(value1);

    const numberEl = selector.querySelector('.kaching-bundles__bar-variant-number:not(.extra-single)');
    let extraEl = selector.querySelector(':scope > .extra-single');

    if (numberEl) {
      // Packs de 2 o mas: Kaching renderiza .bar-variant-number y ahi va todo.
      const markupN = buildVariantLine(titleBase, selectedValues, extraString);
      if (numberEl.innerHTML !== markupN) numberEl.innerHTML = markupN;
      if (isShown(numberEl)) {
        try { alignVariantLine(numberEl, selector); } catch (e) {}
        if (extraEl) extraEl.remove();
        continue;
      }
      // Existe pero esta oculta ("Lleva 1"): seguimos y creamos la linea propia.
    }

    // "Lleva 1": se replica la misma linea que en los packs de 2 o mas
    // (titulo + variante + medidas) dentro del wrapper del selector, como
    // primer hijo.
    if (!selectedValues) continue;

    if (!extraEl) {
      extraEl = document.createElement('div');
      extraEl.className = 'extra-single kaching-bundles__bar-variant-number';
      selector.insertBefore(extraEl, selector.firstChild);
    }

    const markup = buildVariantLine(titleBase, selectedValues, extraString);
    if (extraEl.innerHTML !== markup) extraEl.innerHTML = markup;
    try { alignVariantLine(extraEl, selector); } catch (e) {}
  }
}

function updateVariantTitles() {
  if (!document.querySelector('.h2.product-single__title')) return;

  const selectors = document.querySelectorAll('.label.variant__label');
  if (!selectors.length) return;

  for (let i = 0; i < selectors.length; i++) {
    const selector = selectors[i];
    let stringInitial = 'Copa'

    if (selector.innerHTML.includes('Ancho de la cinta')) {
      stringInitial = 'Ancho de la cinta'
    }

    if (selector.innerHTML.includes('Copa') || selector.innerHTML.includes('Talla') || selector.innerHTML.includes('Ancho de la cinta')) { 
      // Con "Lleva 1" el label no queda dentro de .variant-button-wrap, asi que
      // closest() devuelve null y el .querySelector encadenado lanzaba TypeError,
      // abortando la funcion y dejando la linea de medidas en blanco.
      const wrap = selector.closest('.variant-button-wrap')
        || selector.closest('.variant-wrapper')
        || selector.parentElement;

      const selectedOption = wrap
        ? wrap.querySelector('input[type=radio]:checked+label')
        : null;

      if (selectedOption) {
        const selectedOptionValue = selectedOption.innerHTML.trim();
        const extraString = buildExtraString(selectedOptionValue);
        selector.innerHTML = `${stringInitial} ${extraString}`;
      }
    }
  }
}

function applyDynamicMargin() {
  const sources = document.querySelectorAll('.section-featured-collection-products');

  sources.forEach((source, index) => {
    const el = source;
    const leftDistance = el.getBoundingClientRect().left;
  });
}

let resizeTimeout;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyDynamicMargin();
    try { updateBundleVariantTitles(); } catch (e) {}
  }, 150);
});


function applyDynamicSizes() {
  const allPacks = document.querySelector('.kaching-bundles__bars');
  const selectedPack = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar.kaching-bundles__bar--selected');

  if (!allPacks) return;

  if (selectedPack) {
    const indexSelected = Array.from(allPacks.children).indexOf(selectedPack);

    allPacks.classList.remove('is-one-product')
    allPacks.classList.remove('is-two-products')
    allPacks.classList.remove('is-three-products')

    if (indexSelected == 0) {
      allPacks.classList.add('is-one-product')
    }
    if (indexSelected == 1) {
      allPacks.classList.add('is-two-products')
    }
    if (indexSelected == 3) {
      allPacks.classList.add('is-three-products')
    }
    console.log("Selected pack!", selectedPack, indexSelected)
  }

}

function normalizeTitle(text) {
  if (!text) return '';
  return text.replace(/\uFE0F/g, '').trim();
}

function formatSelectedValues(value1, value2) {
  const values = [value1, value2].filter((value) => value && value !== 'false');
  return values.join(' - ');
}

function sanitizeCollectionText() {
  const titleEls = document.querySelectorAll('.grid-product__title');
  titleEls.forEach((el) => {
    const original = el.textContent || '';
    const cleaned = normalizeTitle(original)
      .replace(/\s*\|\s*false\s*-\s*false/gi, '')
      .replace(/false\s*-\s*false/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (cleaned && cleaned !== original.trim()) {
      el.textContent = cleaned;
    }
  });
}

function relocateLooxWidget() {
  const widget = document.querySelector(".template-index .loox-trust-badge-container.loox-widget");
  const target = document.querySelector(".template-index .hero__text-wrap .hero__subtitle");
  if (!widget || !target || target.contains(widget)) return false;
  target.appendChild(widget);
  return true;
}

window.addEventListener('load', function () {
  enableCart();
});

document.addEventListener('DOMContentLoaded', function () {
  console.log("Initializer")

  relocateLooxWidget();
  const looxObserver = new MutationObserver(() => {
    if (relocateLooxWidget()) looxObserver.disconnect();
  });
  looxObserver.observe(document.body, { childList: true, subtree: true });

  applyDynamicMargin();
  applyDynamicSizes();
  sanitizeCollectionText();

  setTimeout(() => {
    const filterGroupPrice = document.querySelector('.filter-form div[data-collapsible-id="filter-precio"]')
    if (filterGroupPrice) {
      const trigger = filterGroupPrice.closest('.collection-sidebar__group').querySelector('.collapsible-trigger-btn')

      if (trigger) trigger.click()
    }

    const navMobile = document.querySelector('.site-nav__icons')
    if (navMobile) {
      navMobile.classList.add('show-nav')
    }
    
  }, 1300);

  setInterval(() => {
    relocateLooxWidget();

    updateBundleVariantTitles();
    sanitizeCollectionText();
    updateVariantTitles();

  }, 1000);

  document.querySelector('.close-drawer-header').addEventListener('click', () => {
    // location.reload();
    document.querySelector('.site-nav__close-cart').click()
  });

  document.addEventListener('change', function(e) {
    if (e.target.id === 'secure-shipping') {
      const isChecked = e.target.checked;
      const addSecureShippButton = e.target.closest('.cart-segure-shpping').querySelector('.quick-add-secure-shipping button')

      if (isChecked) {
        console.log("Add", addSecureShippButton)

        if (addSecureShippButton) {
          addSecureShippButton.click()
        }
      } else {
        console.log("Rermove")
        const removeSecureButton = e.target.closest('.cart__scrollable').querySelector('.cart__item.is-secure-item .js-qty__num')
        if (removeSecureButton) {
          removeSecureButton.value = 0;

          removeSecureButton.dispatchEvent(new Event('input', { bubbles: true }));
          removeSecureButton.dispatchEvent(new Event('change', { bubbles: true }));

        }
      }
    }
  });

});

/* BoobUp · 17 oct 2026 · Reaccion INMEDIATA al cambiar de pack o de variante.
   Con cada toque dentro del widget de Kaching se actualiza al instante y se
   repite durante ~0,8 s mientras Kaching termina de redibujar. Tambien
   reacciona a cambios de clase en las tarjetas (el pack elegido). */
(function () {
  var timers = [];
  function burst() {
    timers.forEach(clearTimeout); timers = [];
    [0, 40, 120, 250, 450, 800].forEach(function (t) {
      timers.push(setTimeout(function () { try { updateBundleVariantTitles(); } catch (e) {} }, t));
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kaching-bundles')) burst();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.kaching-bundles')) burst();
  }, true);
  function attach() {
    var bars = document.querySelector('.kaching-bundles__bars');
    if (!bars || !window.MutationObserver) return false;
    var last = '';
    new MutationObserver(function () {
      var sel = bars.querySelector(':scope > .kaching-bundles__bar--selected');
      var idx = sel ? Array.prototype.indexOf.call(bars.children, sel) : -1;
      var key = String(idx);
      if (key !== last) { last = key; burst(); }
    }).observe(bars, { attributes: true, attributeFilter: ['class'], subtree: true });
    burst();
    return true;
  }
  if (!attach()) {
    var tries = 0;
    var iv = setInterval(function () { if (attach() || ++tries > 40) clearInterval(iv); }, 300);
  }
})();

/* CTA "Agregar al carrito" dinámico: refleja el precio de la oferta seleccionada de Kaching (con tachado) */
(function () {
  function initAtcDynamicPrice() {
    var wrap = document.querySelector('button.add-to-cart .atc-dyn-price');
    if (!wrap) return;
    var nowEl = wrap.querySelector('.atc-dyn-now');
    var compEl = wrap.querySelector('.atc-dyn-compare');
    if (!nowEl || !compEl) return;

    var sBar = document.getElementById('sticky-atc');
    var sNow = sBar && sBar.querySelector('.sticky-atc__price');
    var sComp = sBar && sBar.querySelector('.sticky-atc__price-compare');
    var sBtnPrice = sBar && sBar.querySelector('.sticky-atc__btn-price');
    var sBtnNow = sBtnPrice && sBtnPrice.querySelector('.sticky-atc__btn-now');
    var sBtnComp = sBtnPrice && sBtnPrice.querySelector('.sticky-atc__btn-compare');

    var ctaOn = !(wrap.getAttribute('data-dynamic-price') === 'false');
    var stickyOn = !(sBar && sBar.getAttribute('data-dynamic-price') === 'false');

    compEl.style.display = 'none';
    if (stickyOn && sComp) sComp.style.display = 'none';
    if (stickyOn && sBtnComp) sBtnComp.style.display = 'none';

    var lastNow = '', committedComp = null, pendComp = null, pendCount = 0, settled = false;

    function readSel() { return document.querySelector('.kaching-bundles__bar--selected'); }
    function readNow(sel) { return ((sel.querySelector('.kaching-bundles__bar-price') || {}).textContent || '').trim(); }
    function readComp(sel) { return ((sel.querySelector('.kaching-bundles__bar-full-price') || {}).textContent || '').trim(); }

    function setComp(comp) {
      if (comp === committedComp) return;
      committedComp = comp;
      if (ctaOn) { if (comp) { compEl.textContent = comp; compEl.style.display = ''; } else { compEl.style.display = 'none'; } }
      if (stickyOn && sComp) { if (comp) { sComp.textContent = comp; sComp.style.display = ''; } else { sComp.style.display = 'none'; } }
      if (stickyOn && sBtnComp) { if (comp) { sBtnComp.textContent = comp; sBtnComp.style.display = ''; } else { sBtnComp.style.display = 'none'; } }
    }

    function update() {
      var sel = readSel();
      if (!sel) { if (ctaOn) wrap.classList.remove('is-on'); return; }
      var now = readNow(sel);
      if (!now) { if (ctaOn) wrap.classList.remove('is-on'); return; }
      if (now !== lastNow) {
        if (ctaOn) nowEl.textContent = now;
        if (stickyOn && sNow) sNow.textContent = now;
        if (stickyOn && sBtnNow) sBtnNow.textContent = now;
        lastNow = now;
        setComp('');
        pendComp = null; pendCount = 0;
      }
      if (settled) {
        var comp = readComp(sel);
        if (comp === committedComp) { pendComp = null; pendCount = 0; }
        else if (comp === pendComp) { if (++pendCount >= 2) { setComp(comp); pendComp = null; pendCount = 0; } }
        else { pendComp = comp; pendCount = 1; }
      }
      if (ctaOn && !wrap.classList.contains('is-on')) wrap.classList.add('is-on');
      if (stickyOn && sBtnPrice && !sBtnPrice.classList.contains('is-on')) sBtnPrice.classList.add('is-on');
    }

    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () { pending = false; update(); });
    }
    function attach() {
      var root = document.querySelector('.kaching-bundles');
      if (!root) return false;
      new MutationObserver(schedule).observe(root, {
        subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']
      });
      update();
      return true;
    }
    if (!attach()) {
      var detector = new MutationObserver(function () {
        if (attach()) detector.disconnect();
      });
      detector.observe(document.documentElement, { subtree: true, childList: true });
    }
    setTimeout(function () { settled = true; }, 1000);
    setInterval(update, 350);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAtcDynamicPrice);
  } else {
    initAtcDynamicPrice();
  }
})();
